export const timePickerMetadata = {
  allowConnectToDB: true,
  skinParamsToIgnore(editorAPI, compRef) {
    const {controller} = editorAPI.documentServices.components.properties.get(compRef);
    return controller !== 'dropdown' ? ['placeholderTextColor'] : [];
  }
};
